import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BLOCKS_CONFIG} from '@blocks/blocks.config';
import {PageBreak} from '@paperlessio/sdk/api/models';

@Component({
  selector: 'app-page-break',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './page-break.component.html',
  styleUrls: ['./page-break.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageBreakComponent {
  blocksConfig = inject(BLOCKS_CONFIG);

  @Input() block: PageBreak;
}
